document.addEventListener('DOMContentLoaded', function () {
  const collapsibleItems = document.querySelectorAll('.collapsible_item-top');

  collapsibleItems.forEach(function (navTitle) {
    const secNavTitle = navTitle.nextElementSibling; // Target sibling content
    const arrowDown = navTitle.querySelector(".collapsible-toggle_icon"); // Arrow icon inside navTitle

    arrowDown.classList.add("inactive"); // Set initial state to inactive

    navTitle.addEventListener("click", function () {
      // Check if the current section is already open
      const isOpen = secNavTitle.classList.contains("collapsed");

      // Close all other sections
      collapsibleItems.forEach(function (otherNavTitle) {
        const otherSecNavTitle = otherNavTitle.nextElementSibling;
        const otherArrowDown = otherNavTitle.querySelector(".collapsible-toggle_icon");

        if (otherNavTitle !== navTitle) {
          otherSecNavTitle.classList.remove("collapsed"); // Close other sections
          otherArrowDown.classList.remove("active");
          otherArrowDown.classList.add("inactive");
        }
      });

      // Toggle the clicked section
      if (isOpen) {
        secNavTitle.classList.remove("collapsed"); // Close if already open
        arrowDown.classList.remove("active");
        arrowDown.classList.add("inactive");
      } else {
        secNavTitle.classList.add("collapsed"); // Open if closed
        arrowDown.classList.remove("inactive");
        arrowDown.classList.add("active");
      }
    });
  });
});